export function zipCodeValidator(value) {
    // regex accepts 00000, 00000-0000, 00000 0000
    return /^\d{5}(?:(?:[-\s]?)\d{4})?$/.test(value);
}
